<div class="row justify-content-md-center align-items-center">
  <div class="col-md-8">
    <div class="container text-center">
      <i class="allycon-checkmark"></i>
      <h1 class="confirmationHeader" aria-live="assertive" tabIndex="-1" id="main-content-focus">{{ CONSTANTS.title }}</h1>
      <div class="confirmation-message mt-2">{{ confirmationMessage }}</div>
    </div>
  </div>
</div>
